import React, { lazy } from 'react';
import { SelectedAccountWatchdog, useTranslation } from '@michelin/central-provider';
import PrivateWrapper from 'components/PrivateWrapper/PrivateWrapper';
import { Switch } from 'react-router-dom';
import { useUFOPaths } from 'utils/paths';
import PrivateRoute from '../components/PrivateRoute';
import genericPageBuilder from '../pages/genericPageBuilder';
import { useStyles } from './appStyle';

const CreateOrderPage = lazy(() => import('compositions/Wizard/CreateOrderPage'));
const OrderDashboard = lazy(() => import('compositions/OrderDashboard/OrderDashboard'));
const OrderDetail = lazy(() => import('compositions/OrderDetail/OrderDetail'));

function Routes() {
  const { PATH_NEW_ORDER, PATH_ORDER_DETAIL, PATH_ORDER_LIST, HOME_PATH } = useUFOPaths();
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.content}>
      <PrivateWrapper>
        <SelectedAccountWatchdog waitForAccountSelector showLoadingBounce>
          <Switch>
            <PrivateRoute path={PATH_NEW_ORDER} component={genericPageBuilder(t('Create Order'), CreateOrderPage)} />
            <PrivateRoute path={PATH_ORDER_LIST} component={genericPageBuilder(t('Orders'), OrderDashboard)} />
            <PrivateRoute path={PATH_ORDER_DETAIL} component={genericPageBuilder(t('Order {{id}}'), OrderDetail, false)} />
            <PrivateRoute path={HOME_PATH} component={genericPageBuilder(t('Orders'), OrderDashboard)} />
          </Switch>
        </SelectedAccountWatchdog>
      </PrivateWrapper>
    </div>
  );
}

export default Routes;
